<template>
  <div>
    <div class="ts-grid ts-grid-cols-1 ts-gap-3">
      <div class="row">
        <div class="col-md-12">
          <label class="ts-mb-0">{{ $t('serviceRequest.technician1') }}</label>
          <a-select
            v-model="model.technician1"
            :options="owners"
            allowClear
            show-search
            option-filter-prop="children"
            class="ts-w-full"
            :class="{ 'is-invalid': errors.has('technician1') }"
            placeholder="Select"
          ></a-select>
          <div class="validate" v-if="errors.has('technician1')">
            {{ errors.first('technician1') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="ts-mb-0">{{ $t('serviceRequest.technician2') }}</label>
          <a-select
            v-model="model.technician2"
            :options="owners"
            allowClear
            show-search
            option-filter-prop="children"
            class="ts-w-full"
            :class="{ 'is-invalid': errors.has('technician2') }"
            placeholder="Select"
          ></a-select>
          <div class="validate" v-if="errors.has('technician2')">
            {{ errors.first('technician2') }}
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <label
            class="ts-mb-0"
            :class="{ required: model.planned_finish_date }"
            >{{ $t('serviceRequest.plannedStartDate') }}</label
          >
          <a-date-picker
            v-model="model.planned_start_date"
            show-time
            format="DD-MM-YYYY HH:mm:ss"
            valueFormat="DD-MM-YYYY HH:mm:ss"
            class="ts-w-full"
            :class="{ 'is-invalid': errors.has('planned_start_date') }"
            placeholder="Select Date Time"
          ></a-date-picker>
          <div class="validate" v-if="errors.has('planned_start_date')">
            {{ errors.first('planned_start_date') }}
          </div>
        </div>
        <div class="col-md-6">
          <label class="ts-mb-0">{{
            $t('serviceRequest.plannedFinishDate')
          }}</label>
          <a-date-picker
            v-model="model.planned_finish_date"
            show-time
            format="DD-MM-YYYY HH:mm:ss"
            valueFormat="DD-MM-YYYY HH:mm:ss"
            class="ts-w-full"
            :class="{ 'is-invalid': errors.has('planned_finish_date') }"
            placeholder="Select Date Time"
          ></a-date-picker>
          <div class="validate" v-if="errors.has('planned_start_date')">
            {{ errors.first('planned_start_date') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label class="ts-mb-0" :class="{ required: model.close_date }">{{
            $t('serviceRequest.openDate')
          }}</label>
          <a-date-picker
            v-model="model.open_date"
            show-time
            format="DD-MM-YYYY HH:mm:ss"
            valueFormat="DD-MM-YYYY HH:mm:ss"
            class="ts-w-full"
            :class="{ 'is-invalid': errors.has('open_date') }"
            placeholder="Select Date Time"
            @change="onChangeOpenDate"
          ></a-date-picker>
          <div class="validate" v-if="errors.has('open_date')">
            {{ errors.first('open_date') }}
          </div>
        </div>
        <div class="col-md-6">
          <label class="ts-mb-0">{{ $t('serviceRequest.closeDate') }}</label>
          <a-date-picker
            v-model="model.close_date"
            show-time
            format="DD-MM-YYYY HH:mm:ss"
            valueFormat="DD-MM-YYYY HH:mm:ss"
            class="ts-w-full"
            :class="{ 'is-invalid': errors.has('close_date') }"
            placeholder="Select Date Time"
            @change="onChangeCloseDate"
          ></a-date-picker>
          <div class="validate" v-if="errors.has('close_date')">
            {{ errors.first('close_date') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label class="ts-mb-0">{{ $t('serviceRequest.plateNumber') }}</label>
          <a-select
            v-model="model.plate_number"
            :options="vehiclePlate"
            show-search
            option-filter-prop="children"
            class="ts-w-full"
            :class="{
              'is-invalid': errors.has('plate_number')
            }"
            placeholder="Select"
          ></a-select>
          <div class="validate" v-if="errors.has('plate_number')">
            {{ errors.first('plate_number') }}
          </div>
        </div>
        <div class="col-md-6">
          <ts-checkbox
            v-model="model.required_spare_part"
            class="ts-font-robot ts-mt-4"
          >
            {{ $t('serviceRequest.requiredSparePart') }}
          </ts-checkbox>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="ts-mb-0 ts-font-robot">{{
            $t('serviceRequest.remarks')
          }}</label>
          <textarea
            v-model="model.remarks"
            rows="5"
            class="form-control"
            placeholder="Note something here"
          ></textarea>
          <div class="validate" v-if="errors.has('remarks')">
            {{ errors.first('remarks') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
export default {
  props: ['value', 'validate'],
  components: {},
  data() {
    return {
      loading: false,
      errors: new Errors(),
      show_project: false,
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    ...mapState('serviceManagement/serviceRequest', ['formViewDatas']),
    owners() {
      if (this.formViewDatas['owners']) {
        return this.formViewDatas['owners'].map(el => ({
          value: el.user_id,
          label: el.employee_name_kh + '|' + el.employee_name_en
        }))
      }
      return []
    },
    vehiclePlate() {
      if (this.formViewDatas['vehiclePlate']) {
        return this.formViewDatas['vehiclePlate'].map(el => ({
          value: el.plate_number,
          label: el.plate_number
        }))
      }
      return []
    }
  },
  methods: {
    onChangeOpenDate() {
      if (this.model.close_date) {
        this.model.service_status = 2
      }
      if (!this.model.close_date) {
        this.model.service_status = 1
      }
    },
    onChangeCloseDate() {
      if (this.model.close_date != null) {
        this.model.service_status = 2
      }
      if (this.model.close_date == null) {
        this.model.service_status = 1
      }
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
<style>
.ant-calendar-picker-input {
  height: 32px !important;
}
</style>
<style scoped>
* {
  font-family: Roboto, Khmer, 'Font Awesome 5 Free';
}
</style>
